import React from 'react'
import styled from 'styled-components'
import { RecipeLabel } from '../../Kiosk/style'

import LabelIcons from '../../LabelIcons/LabelIcons'

const Cell = styled.div`
    font-size: 1em;
    font-weight: 300;
    line-height: 2em;
`

const cellItems = props => {
    let result = null
    const {
        items,
        dataSource,
        hideLabels,
        hideIntolerences,
        hideMenuPrice,
        hideRecipePoints,
        hideEnergyKcal,
        showEnergyKcalByPortion
    } = props

    if (items) {
        result = items
            .filter(_ => _.menu_board_label)
            .map((item, index) => (
                <div key={index}>
                    {item.menu_board_label}

                    {!hideEnergyKcal && (
                        showEnergyKcalByPortion ? (
                            !!item.energyKCalByPortion && <span>&nbsp;({item.energyKCalByPortion} kCal)</span>
                        ) : (
                            !!item.energyKCal && (
                                <span>
                                    &nbsp;(
                                    {item.energyKCal}
                                    &nbsp;kCal
                                    <sup style={{ marginLeft: '0.2em', fontSize: '0.6em' }}>100g</sup>
                                    )
                                </span>
                            )
                        )
                    )}
                    {!hideRecipePoints && item.price_point ? (
                        <span>&nbsp;({item.price_point})</span>
                    ) : null}
                    {(!hideLabels && item.label) && (
                        <RecipeLabel
                            style={{
                              
                            }}
                            src={`img/labels/${item.label}.png`}
                            onError={i => (i.target.style.display = 'none')}
                        />
                    )}

                    {!hideLabels && item.caracteristique_produit && (
                        <RecipeLabel
                            src={`img/labels/${item.caracteristique_produit}.png`}
                            onError={i => (i.target.style.display = 'none')}
                        />
                    )}
                    {!hideIntolerences && (
                        <LabelIcons item={item} dataSource={dataSource} />
                    )}
                </div>
            ))
    }
    return <Cell>{result}</Cell>
}

export default cellItems
